<div id="private-security-container">
    <div class="section-title-container">
        <h2 class="section-title">Seguridad privada</h2>
    </div>

    <div id="private-security-content-container">
        @for (card of cards; track $index) {
            <app-section-card class="private-security-card" [type]="'private-security'" [card]="card"></app-section-card>
        }

    </div>
</div>
